import React from 'react';

import { withTranslation } from 'providers/GILT.provider';

class ClientItem extends React.Component {
  static defaultProps = { children: [] };

  constructor(props) {
    super(props);
    this.state = { expanded: false };
    this.divElement = React.createRef();
  }

  expandedText = () => {
    this.setState({ expanded: !this.state.expanded });
  };

  render() {
    const { onClick, children, notes, initials, known_as: knownAs, rank, user_name: userName, t } = this.props;
    const { expanded } = this.state;
    const divRef = this.divElement;

    return (
      <div data-bem="ClientItem" className="toggle-notes-container">
        <div role="button" tabIndex="0" className="o-item cfix" onClick={onClick}>
          <div className="initials">
            <span>{initials} </span>
          </div>

          <table>
            <tbody>
              <tr className="o-name f-r">
                <th data-rank={rank}>{userName}</th>
              </tr>
              <tr className="o-phone 2">
                <td>{knownAs || ''}</td>
              </tr>
              <tr className="o-phone 4">{children}</tr>
              <tr className="o-phone 5">
                <td>
                  <div className={expanded ? 'item-description open' : 'item-description '}>
                    <span ref={divRef} className={expanded ? 'note-text' : 'note-text clip'}>
                      {notes || ''}
                    </span>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className={expanded ? 'link-more open' : 'link-more '} ref={divRef}>
          {notes && notes.length >= 90 ? (
            <span role="button" tabIndex={0} className="show-more-text" onClick={() => void this.expandedText()}>
              {t(expanded ? 'scheduler.clientItem.viewLess' : 'scheduler.clientItem.viewMore')}
            </span>
          ) : (
            <div />
          )}
        </div>
      </div>
    );
  }
}

const ClientItemHoc = withTranslation()(ClientItem);

export default ClientItemHoc;
